// extracted by mini-css-extract-plugin
export default {"container":"MobileTopicHeader_container__JN7PK","query__input":"MobileTopicHeader_query__input__BYETS","filter__fields":"MobileTopicHeader_filter__fields__x+Pl3"};